import { SelectOption } from "../types";
import { FormStateType } from "..";

export const hasValueChanged = (
  state: FormStateType,
  name: string,
  newValue?: string | number | SelectOption,
) => {
  const prevValue = state && state[name];

  return prevValue !== newValue;
};
